import React from "react";
import TopCarousel from "./TopCarousel";
import Introduction from "./Introduction";
import Timer from "../components/Timer";

// const axios = require("axios");

class Home extends React.Component {
  componentDidMount() {
    document.title =
      "CAAIE 2026 : Conference on Advanced Artificial Intelligence and Education (CAAIE)";
  }
  render() {
    return (
      <div>
        <TopCarousel />
        {/* <Timer /> */}
        <Introduction />
      </div>
    );
  }
}

export default Home;
